import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetAuftraegeMutation } from '../../api/AgSachbearbeiterAPI';
import { useGetAuftragTableOrderServiceMutation, useSetAuftragTableOrderServiceMutation } from '../../api/ProfileAPI';
import AuftragCustomerDetailComponent from '../../component/AuftragCustomerDetailComponent/AuftragCustomerDetailComponent';
import ScrollToTopBadge from '../../component/ScrollToTop';
import { IAgSachbearbeiterListResponseDto, IAgSbAuftragTableOrderColumns } from '../../types/Types';
import { formatToEuroDate } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from "./agsachbearbeiter.module.scss";


/**
 * @author noone
 */
export default function AgSbAuftragsListe() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [getProfileParameter] = useGetAuftragTableOrderServiceMutation();
  const [setProfileParameter] = useSetAuftragTableOrderServiceMutation();
  const [getAuftraege] = useGetAuftraegeMutation();

  const parameterName = "agsbauftragsliste";

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [liste, setListe] = useState<IAgSachbearbeiterListResponseDto[]>([]);
  const [originalListe, setOriginalListe] = useState<IAgSachbearbeiterListResponseDto[]>([]);
  const [sortList, setSortList] = useState(new Map<number, number>());

  const [uid, setUid] = useState<string>();

  const init = () => {
    setLoaded(false);
    getAuftraege().unwrap()
      .then(data => {
        setOriginalListe(data);
        setListe(data.slice());

        getProfileParameter(parameterName).unwrap().then((dto: IAgSbAuftragTableOrderColumns) => {
          if (dto) {
            setSortList(new Map([
              [1, dto.art], // Art
              [2, dto.status], // Status
              [3, dto.auftragsnr], // Name
              [4, dto.name], // Lieferort
              [5, dto.lieferort], // Termin
              [6, dto.erstellt_am],  // Erstellt am
              [7, dto.bearbeiter],  // Erstellt am
              [8, dto.erstellt_am]  // Erstellt am
            ]));
          }
        }).catch((error) => {
          setSortList(new Map([
            [1, 0], // Art
            [2, 0], // Status
            [3, 0], // 
            [4, 0], // 
            [5, 0], // 
            [6, 0], // 
            [7, 0], // 
            [8, 0]  // 
          ]));
        });
      })
      .catch((e) => console.log(e))
      .finally(() => setLoaded(true));
  }

  const onSpeichern = () => {
    setUid(undefined);
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    init();
  }, [getAuftraege]);

  const sort = (number: number) => {
    sortList.forEach((value, key) => {
      if (key !== number) {
        sortList.set(key, 0);
      } else {
        if (value === 0) {
          sortList.set(key, 1);
        } else if (value === 1) {
          sortList.set(key, -1);
        } else {
          sortList.set(key, 0);
        }
      }
    });
    sortListeByColumn(number);

    saveColumnOrder();
  }

  const sortListeByColumn = (column: number) => {
    liste.sort((a, b) => {
      if (column === 1) {
        if (sortList.get(column) === 1) {
          return a.art > b.art ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.art > b.art ? -1 : 1;
        } else return 0;
      } else if (column === 2) {
        if (sortList.get(column) === 1) {
          return a.status > b.status ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.status > b.status ? -1 : 1;
        } else return 0;
      } else if (column === 3) {
        if (sortList.get(column) === 1) {
          return a.auftragsnr_ag > b.auftragsnr_ag ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.auftragsnr_ag > b.auftragsnr_ag ? -1 : 1;
        } else return 0;
      } else if (column === 4) {
        if (sortList.get(column) === 1) {
          return a.name_endkunde > b.name_endkunde ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.name_endkunde > b.name_endkunde ? -1 : 1;
        } else return 0;
      } else if (column === 5) {
        if (sortList.get(column) === 1) {
          return a.stadt_lieferadresse > b.stadt_lieferadresse ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.stadt_lieferadresse > b.stadt_lieferadresse ? -1 : 1;
        } else return 0;
      } else if (column === 6) {
        const dateA = a.aktuellerTermin ? new Date(a.aktuellerTermin).getTime() : 0;
        const dateB = b.aktuellerTermin ? new Date(b.aktuellerTermin).getTime() : 0;
        if (sortList.get(column) === 1) {
          return dateA - dateB;
        } else if (sortList.get(column) === -1) {
          return dateB - dateA;
        } else return 0;
      } else if (column === 7) {
        if (sortList.get(column) === 1) {
          return a.bearbeiterName > b.bearbeiterName ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.bearbeiterName > b.bearbeiterName ? -1 : 1;
        } else return 0;
      } else if (column === 8) {
        const dateA = a.createDate ? new Date(a.createDate).getTime() : 0;
        const dateB = b.createDate ? new Date(b.createDate).getTime() : 0;
        if (sortList.get(column) === 1) {
          return dateA - dateB;
        } else if (sortList.get(column) === -1) {
          return dateB - dateA;
        } else return 0;

      } else return 0;
    });

    setListe([...liste]);
  }

  const getIconBySort = (column: number) => {
    if (sortList.get(column) === -1) {
      return "bi bi-arrow-down";
    } else if (sortList.get(column) === 1) {
      return "bi bi-arrow-up";
    } else {
      return "bi bi-arrow-down-up";
    }
  }

  const suche = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value.toLowerCase();

    if (searchTerm === "") {
      setListe(originalListe);
      return;
    }

    const suchbegriffe = searchTerm.trim().split(" ");

    var liste1 : IAgSachbearbeiterListResponseDto[] = originalListe;

    suchbegriffe.forEach(term => {

      var liste2 = liste1.filter(auftrag =>
        (auftrag.vorname_endkunde + " " + auftrag.name_endkunde).toLowerCase().includes(term) ||
        auftrag.stadt_lieferadresse.toLowerCase().includes(term) ||
        auftrag.art.toLowerCase().includes(term) ||
        auftrag.status.toLowerCase().includes(term) ||
        auftrag.auftragsnr_ag.toLowerCase().includes(term) ||
        (auftrag.bearbeiterName && auftrag.bearbeiterName.toLowerCase().includes(term))
      );

      liste1 = [...liste2];
    });

    // Duplikate basierend auf uid eliminieren
    const uniqueListe = Array.from(new Map(liste1.map(item => [item.uid, item])).values());
    setListe(uniqueListe);
  }

  const getFarbeZuStatus = (status: string) => {
    if (status === "NEU") {
      return "lightblue";
    } else if (status === "IN_TERMINIERUNG") {
      return "lightblue";
    } else if (status === "IN_TERMINIERUNG") {
      return "yellow";
    } else if (status === "FERTIG") {
      return "lightgreen";
    } else
      return "white";
  }

  const saveColumnOrder = () => {
    var dto: IAgSbAuftragTableOrderColumns = {
      art: sortList.get(1) || 0,
      status: sortList.get(2) || 0,
      auftragsnr: sortList.get(3) || 0,
      name: sortList.get(4) || 0,
      lieferort: sortList.get(5) || 0,
      termin: sortList.get(6) || 0,
      bearbeiter: sortList.get(7) || 0,
      erstellt_am: sortList.get(8) || 0,
    }

    setProfileParameter({
      key: parameterName,
      value: JSON.stringify(dto)
    }).catch((error) => {
      console.error("Error saving column order:", error);
    });
  }

  useEffect(() => {
    sortList.forEach((value, key) => {
      if (value !== 0) {
        console.log("Sorting by column:", key, "with value:", value);
        sortListeByColumn(key);
      }
    });

  }, [sortList]);

  return (
    <>
      <ScrollToTopBadge />

      <LandingpageHeader />
      
      <div style={{ marginLeft: "3em", marginRight: "3em" }} >

        {!uid &&
          <>
            <div>

              <button
                onClick={() => {
                  navigate({
                    pathname: "/",
                    search: ""
                  });
                }}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragMain.backButton')}
              </button>

            </div>

            <h3>{t('deTranslation.auftragMain.titel')}</h3>

            {liste?.length === 0 && <div>Keine Aufträge vorhanden</div>}

            {liste?.length !== 0 && <p>
              Anzahl {liste.length}
            </p>}

            Suche : <input type="text" className='form-control' placeholder='Suche' onChange={suche} />

            <table className="table table-striped">

              <thead>
                <tr>
                  <th onClick={() => { sort(1) }}>Art <i style={{ marginLeft: "10px" }} className={getIconBySort(1)} /></th>
                  <th onClick={() => { sort(2) }}>Status <i style={{ marginLeft: "10px" }} className={getIconBySort(2)} /></th>
                  <th onClick={() => { sort(3) }}>Auftragsnr. <i style={{ marginLeft: "10px" }} className={getIconBySort(3)} /></th>
                  <th onClick={() => { sort(4) }}>Name <i style={{ marginLeft: "10px" }} className={getIconBySort(4)} /></th>
                  <th onClick={() => { sort(5) }}>Lieferort <i style={{ marginLeft: "10px" }} className={getIconBySort(5)} /></th>
                  <th onClick={() => { sort(6) }}>Termin <i style={{ marginLeft: "10px" }} className={getIconBySort(6)} /></th>
                  <th onClick={() => { sort(7) }}>Bearbeiter <i style={{ marginLeft: "10px" }} className={getIconBySort(7)} /></th>
                  <th onClick={() => { sort(8) }}>Erstellt am <i style={{ marginLeft: "10px" }} className={getIconBySort(8)} /></th>
                  <th>Option</th>
                </tr>
              </thead>
              <tbody>
                {
                  liste?.slice().map((e, index) => (
                    <tr key={e.uid} >
                      <td style={{ padding: "12px 16px" }}>{e.art}</td>
                      <td style={{ padding: "12px 16px" }}><label style={{ borderRadius: "10px", border: "none", padding: "10px", backgroundColor: getFarbeZuStatus(e.status) }}>{e.status}</label></td>
                      <td style={{ padding: "12px 16px" }}>{e.auftragsnr_ag}</td>
                      <td style={{ padding: "12px 16px" }}>{e.vorname_endkunde} {e.name_endkunde}</td>
                      <td style={{ padding: "12px 16px" }}>{e.stadt_lieferadresse}</td>
                      <td style={{ padding: "12px 16px" }}>{formatToEuroDate(e.aktuellerTermin)}</td>
                      <td style={{ padding: "12px 16px" }}>{e.bearbeiterName}</td>
                      <td style={{ padding: "12px 16px" }}>{formatToEuroDate(e.createDate)}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <button onClick={() => setUid(e.uid)} className={styles.wga} ><i className="bi bi-pencil"></i></button>
                      </td>
                    </tr>
                  ))
                }
              </tbody >

            </table>
          </>
        }

        {
          uid &&
          <>
            <div>

              <button
                onClick={() => setUid(undefined)}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
              </button>

            </div>

            <h3>{t('deTranslation.auftragDetails.titel')}</h3>
            <AuftragCustomerDetailComponent uid={uid} onSpeichern={onSpeichern} />
          </>
        }

        <Footer />
      </div >
    </>
  );

}


